import { api } from '@/global/services/api'
import { isObject } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import documentsHistoryHelper from '../documents-history-helper'
import { notify } from '@/global/services/notification/notificationBus'
import tabsHelper from '../tabs-helper'

const DOCUMENTS_HISTORY_DATA_KEY = 'invitationDocuments'
const DOCUMENT_TYPE = 'scene_investigation_invitation'
export default {

  mixins: [
    documentsHistoryHelper,
    tabsHelper
  ],

  data () {
    return {
      invitationHistoryVisible: false,
      invitationShowEditButtons: false,
      invitationEditState: false,
      invitationShowDocumentPreview: false,
      invitationDocument: null,
      invitationDataForGenerationVisible: true,
      invitationTitle: this.$t('road-maintenance/aggregator.invitation_to_inspection'),
      invitationBaseTitle: this.$t('road-maintenance/aggregator.invitation_to_inspection'),
      invitationValidationErrors: {},
      invitationShowLoader: false,
      invitationDocumentHistoryLoaded: false,
      invitationRefreshDisabled: false,
      itiDocumentLoaders: [],
      showItiTabLoader: null
    }
  },

  computed: {
    invitationToInspectionConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.invitation_to_inspection'),
        visible: this.$route.query.category !== 'request_new',
        key: 'invitation-to-inspection',
        validationErrors: this.invitationValidationErrors,
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}/store`,
            usePatch: false,
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`,
            method: 'get'
          }
        },
        edit: this.invitationEditState,
        editUpdate: (event) => this.onInvitationEditUpdate(event),
        dataFetched: (event) => this.onInvitationDataFetched(event),
        afterCancel: (event) => this.onInvitationDataFetched(event),
        afterSave: (event) => this.onInvitationDataFetched(event, true),
        modifyDataBeforeSend: (event) => this.onInvitationModifyData(event),
        showLoader: this.showItiTabLoader,
        hiddenFormKeys: [
          'html'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.invitationTitle,
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            forceAdditionalButtonsDisplay: true,
            showEditButtons: this.invitationShowEditButtons,
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                visible: !this.invitationShowEditButtons,
                disabled: this.invitationRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  this.invitationRefreshDisabled = true

                  await fetchTabData?.()
                  await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

                  setTimeout(() => {
                    this.invitationRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: !this.invitationShowEditButtons && !!this.permissions?.canChangeStatus,
                click: (event) => this.onChangeStatus(event)
              },
              {
                type: 'dropdown',
                buttonType: 'base',
                label: this.$t('road-maintenance/aggregator.generate_document'),
                color: '#65AD45',
                class: 'generate-document-btn',
                visible: !this.invitationShowEditButtons && !!this.permissions?.canCreate,
                menuContentClass: 'menu-class',
                hasHistoryData: this.logsData?.[DOCUMENTS_HISTORY_DATA_KEY]?.length,
                component: this.documentsGenerationDropdownMenuComponent,
                menuItemClick: (event) => this.invitationMenuItemClick(event)
              },
              {
                type: 'base',
                label: this.viewPdfBtnLabel,
                color: '#6e736d',
                visible: this.invitationShowEditButtons,
                class: 'generate-document-btn',
                loaderConfig: {
                  opacity: 0,
                  color: '#FFFFFFF'
                },
                showLoader: this.showPreviewLoader,
                click: (event) => this.previewDocument(event, DOCUMENT_TYPE, this.invitationBaseTitle)
              }
            ],
            onCancelTabSave: () => this.onInvitationCancelTab(),
            onSaveClick: (event) => this.onInvitationSave(event)
          },
          // Data for document generation
          {
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.data_for_document_generation'),
            visible: this.invitationDataForGenerationVisible,
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'doc_class',
                    label: this.$t('road-maintenance/aggregator.class'),
                    row: 1,
                    column: 1,
                    colSpan: 1,
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'registry_number',
                    row: 1,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.registration_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'created_at',
                    type: 'datetime-picker',
                    subType: 'date',
                    row: 1,
                    column: 3,
                    colSpan: 1,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.date,
                    placeholder: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.document_date'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          created_at: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'addresses',
                    row: 2,
                    column: 1,
                    colSpan: 2,
                    label: this.$t('road-maintenance/aggregator.request_locations'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'work_type',
                    type: 'textarea',
                    row: 2,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.type_of_works_or_actions'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'applicant_name',
                    row: 3,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/prp.request_applicant'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'applicant_street_name',
                    row: 3,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.applicant_address_street'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'applicant_house_number',
                    row: 3,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.applicant_address_house_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'other_participants',
                    type: 'textarea',
                    row: 4,
                    column: 1,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.other_participants'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  },
                  {
                    key: 'date_address',
                    type: 'textarea',
                    row: 4,
                    column: 2,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.date_and_address_of_inspection'),
                    unlock: !!this.permissions?.canCreate,
                    creatable: true,
                    editable: true,
                    visible: true,
                    doubleClickEdit: false
                  }
                ]
              }
            ]
          },
          // Document history
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.log_history'),
            visible: this.invitationHistoryVisible,
            externalData: this.logsData,
            dataKey: DOCUMENTS_HISTORY_DATA_KEY,
            columnsConfig: [
              {
                key: 'created_at',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.date') + ':',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.datetimeShort) : ''
                }
              },
              {
                key: 'status',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/excavation-service.status') + ':',
                customValue: (data) => {
                  return data?.status ? this.$t(data.status) : '-'
                }
              },
              {
                key: 'user',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.user') + ':'
              },
              {
                key: 'document',
                valueClass: 'history-block-value',
                visible: (event) => {
                  return event?.blockValue !== '-'
                },
                loaderIds: this.itiDocumentLoaders,
                title: this.$t('road-maintenance/aggregator.document') + ':',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                customValue: (data) => {
                  return data?.document?.name ? data.document.name : '-'
                },
                click: (event) => this.onItiDownloadDocument(event)
              },
              {
                visible: (event) => {
                  return !!event?.rowData?.document_data_id
                },
                component: this.createFromVersionBtnComponent,
                class: 'create-from-version-btn-block',
                onClick: (event) => this.onItiCreateFromVersion(event)
              }
            ]
          },
          {
            component: this.documentPreviewComponent,
            visible: this.invitationShowDocumentPreview,
            content: this.invitationDocument,
            showLoader: this.invitationShowLoader
          }
        ]
      }
    }
  },

  methods: {
    async onItiDownloadDocument (event) {
      const { id: documentId } = event?.rowData || {}
      // skip if download is already in progress
      if (this.itiDocumentLoaders.includes(documentId)) {
        return
      }
      // show document loader
      if (documentId && !this.itiDocumentLoaders.includes(documentId)) {
        this.itiDocumentLoaders.push(documentId)
      }

      // download document
      await this.downloadDocument(event)
      // stop document loader
      if (this.itiDocumentLoaders.includes(documentId)) {
        this.itiDocumentLoaders = this.itiDocumentLoaders.filter(activeLoaderId => activeLoaderId !== documentId)
      }
    },

    async onInvitationGenerateDocument (event, showLast = false) {
      try {
        const { formData } = event || {}
        const { id } = this?.$route?.params || {}
        this.showItiTabLoader = true

        // validate data
        if (!id) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Missing traffic regulation id')
          return
        }
        if (!isObject(formData)) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Form data is invalid', formData)
          return
        }

        // Create formData object for sending
        const dataToSend = new FormData()
        dataToSend.append('other_participants', formData?.other_participants ?? '')
        dataToSend.append('date_address', formData?.date_address ?? '')
        dataToSend.append('show_last_version', showLast)
        dataToSend.append('created_at', formData?.created_at ? dateService.formatCustom(formData.created_at, FORMATS.date, FORMATS.isoDate) : '')

        // Get document html
        const { data } = await api('road-maintenance').post(`traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`, dataToSend)

        this.invitationDocument = data
        this.invitationShowDocumentPreview = true
        this.invitationEditState = true
        this.invitationShowEditButtons = true
        this.invitationDataForGenerationVisible = false
        this.invitationTitle = this.$t('road-maintenance/aggregator.inspection_invitation_document_overview')
      }
      catch (exception) {
        const { errors } = exception?.response?.data || {}
        this.invitationValidationErrors = errors && isObject(errors) ? errors : {}
        console.error(exception)
      }
      finally {
        this.showItiTabLoader = false
      }
    },

    async onItiCreateFromVersion (event) {
      try {
        this.showItiTabLoader = true

        // get document data
        const data = await this.createFromVersion(event, DOCUMENT_TYPE)

        const { html, css } = data || {}
        // do not open document if data is invalid
        if (!html && !css) {
          return
        }

        // set document data and open document preview
        this.invitationDocument = data
        this.invitationShowDocumentPreview = true
        this.invitationEditState = true
        this.invitationShowEditButtons = true
        this.invitationDataForGenerationVisible = false
        this.invitationTitle = this.$t('road-maintenance/aggregator.inspection_invitation_document_overview')
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showItiTabLoader = false
      }
    },

    onInvitationCancelTab () {
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.data_not_saved_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.invitationCancel())
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    invitationCancel () {
      this.invitationEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
    },

    onInvitationSave (event) {
      const { saveTab } = event || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('road-maintenance/aggregator.document_will_be_uploaded_to_centrix_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.onInvitationSaveConfirmation(saveTab))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    onInvitationSaveConfirmation (saveTabFn) {
      if (typeof saveTabFn === 'function') {
        saveTabFn()
      }

      this.invitationEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
      this.$set(this.informationDialogConfig, 'title', this.informationDialogBaseConfig.title)
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', this.informationDialogBaseConfig.confirmCallbackFunction)
    },

    onInvitationEditUpdate (event) {
      const { edit } = event || {}
      this.invitationHistoryVisible = !edit

      if (!edit) {
        this.invitationShowDocumentPreview = false
        this.invitationEditState = false
        this.invitationShowEditButtons = false
        this.invitationDataForGenerationVisible = true
        this.invitationDocument = null
        this.invitationTitle = this.invitationBaseTitle
      }
    },

    async onInvitationDataFetched (event, afterSave = false) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          created_at: data?.created_at && !dateService.isValid(data.created_at, FORMATS.date, true) ? dateService.formatCustom(data.created_at, FORMATS.isoDate, FORMATS.date) : dateService.now(FORMATS.date),
          // Update applicant
          applicant_name: data?.applicant?.name ?? '',
          applicant_house_number: data?.applicant?.address_number ?? null,
          applicant_street_name: data?.applicant?.address_street ?? null
        })
      }

      if (!this.invitationDocumentHistoryLoaded || afterSave) {
        this.invitationDocumentHistoryLoaded = true
        const { id: suggestedStatusId, description } = data?.suggested_status || {}

        // Fetch documents logs
        await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

        // Open change status popup after documents save only if we have suggested status provided
        if (suggestedStatusId) {
          this.$set(this.afterDocumentStatusChangeActions, 'statusId', suggestedStatusId)
          const message = this.$t('road-maintenance/aggregator.status_change_message')
          this.$set(this.informationDialogConfig, 'showDialog', afterSave)
          this.$set(this.informationDialogConfig, 'message', '<div> ' + message + '<span style="font-style: italic; color: green;">' + ' ' + this.$t(description) + '</span>?</div>')
        }
      }
    },

    onInvitationModifyData (event) {
      const { originalData } = event || {}

      if (originalData) {
        originalData.created_at = originalData?.created_at ? dateService.formatCustom(originalData.created_at, FORMATS.date, FORMATS.isoDate) : null
      }

      return originalData
    },

    async invitationMenuItemClick (event) {
      const { menuIndex } = event || {}
      await this.onInvitationGenerateDocument(event, menuIndex === 1)
    }
  }
}
